module.exports = __webpack_public_path__ + "img/dis05.4d4a11bc.svg";